export function calculateEffectiveEndDate(createdAt: string, today: Date = new Date()): string {
  const created = new Date(createdAt);
  const billingDay = created.getUTCDate();
  const todayUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));

  let year = todayUTC.getUTCFullYear();
  let month = todayUTC.getUTCMonth();

  const candidate = new Date(Date.UTC(year, month, billingDay));
  if (candidate.getUTCMonth() !== month) {
    candidate.setUTCDate(0);
  }

  if (candidate <= todayUTC) {
    month += 1;
    if (month > 11) { month = 0; year += 1; }
    const next = new Date(Date.UTC(year, month, billingDay));
    if (next.getUTCMonth() !== month) {
      next.setUTCDate(0);
    }
    return next.toISOString().slice(0, 10);
  }

  return candidate.toISOString().slice(0, 10);
}

export function formatDateNL(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}-${m}-${y}`;
}
